import { CompPackOrderTicketValues } from "./CompPackOrderTicketValues";
import { CompPackOrderRentalValues } from "./CompPackOrderRentalValues";
import { CompPackOrderLessonProgramValues } from "./CompPackOrderLessonProgramValues";
import { CompPackOrderLessonValues } from "./CompPackOrderLessonValues";
import { LessonProperty } from "../../../Modules/Account/CustomerLessonProperties";

export class CompPackBookingValues {
    constructor(projNr: number, packageId: number, tariffSheetId: number, soapDateStart: string, soapDateEnd: string) {
        this.projNr = projNr;
        this.packageId = packageId;
        this.tariffSheetId = tariffSheetId;
        this.soapDateStart = soapDateStart;
        this.soapDateEnd = soapDateEnd;
        this.ticketOrderValues = new Array<CompPackOrderTicketValues>();
        this.rentalOrderValues = new Array<CompPackOrderRentalValues>();
        this.additionalRentalOrderValues = new Array<CompPackOrderRentalValues>();
        this.lessonProgramOrderValues = new Array<CompPackOrderLessonProgramValues>();
        this.lessonOrderValues = new Array<CompPackOrderLessonValues>();
    }

    projNr: number;
    packageId: number;
    tariffSheetId: number;
    soapDateStart: string;
    soapDateEnd: string;

    accountId: number;
    gender: string;
    height: number;
    weight: number;
    shoeSize: number;
    skillLevel: number;
    pickupLocationId: number;

    lessonAllergies: LessonProperty[] = [];
    lessonMedicals: LessonProperty[] = [];
    lessonLanguages: LessonProperty[] = [];
    lessonLevels: LessonProperty[] = [];

    ticketOrderValues: CompPackOrderTicketValues[];
    rentalOrderValues: CompPackOrderRentalValues[];
    additionalRentalOrderValues: CompPackOrderRentalValues[];
    lessonProgramOrderValues: CompPackOrderLessonProgramValues[];
    lessonOrderValues: CompPackOrderLessonValues[];
}